/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * What a container action is requested for: to place, collect or empty a container, or to exchange one.
 */
export enum EnumContainerActionRequest {
    /**
     * The container is collected from the site
     */
    Collect = 1,
    /**
     * The container is emptied where it stands
     */
    Empty = 2,
    /**
     * The container is collected and another one is brought in its place
     */
    Exchange = 3,
    /**
     * A container is placed at the site
     */
    Place = 4,
}
